<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1 class="text-xs-center mb-3">Reports</h1>
      </v-flex>

      <v-flex xs12 mb-3>
        <v-layout row wrap>
          <v-flex xs12 sm2 class="pl-2">
            <v-select
              class="v-select--fixed-width"
              :items="reportTypeOptions"
              v-model="selectedReportType"
              item-text="text"
              item-value="value"
              label="Report Type"
              :menu-props="{ offsetY: true }"
              :disabled="loadingFilters"
            ></v-select>
          </v-flex>

          <v-flex xs12 sm3 class="pl-2 account-owner-filter-col" v-if="showAccountOwnerFilter">
            <transportation-owner-autocomplete
              class="account-owner-select"
              v-model="selectedAccountOwner"
              label="Account"
              placeholder="Search account owner"
              :disabled="loadingFilters"
            />
          </v-flex>

          <v-flex xs12 :sm3="showAccountOwnerFilter" :sm4="!showAccountOwnerFilter" class="pl-2">
            <v-select
              :items="vehicleOptions"
              v-model="selectedVehicleIds"
              item-text="text"
              item-value="value"
              label="Vehicles"
              placeholder="All"
              multiple
              :disabled="loadingFilters"
              :menu-props="{ maxHeight: '320', offsetY: true }"
            >
              <template v-slot:selection="{ item, index }">
                <span
                  v-if="index === 0"
                  class="selection-summary-text"
                  :title="item && item.text ? item.text : String(item)"
                >
                  {{ item && item.text ? item.text : item }}
                </span>
                <span v-else-if="index === 1" class="selection-summary-count">
                  (+{{ selectedVehicleIds.length - 1 }} more)
                </span>
              </template>
            </v-select>
          </v-flex>

          <v-flex xs12 sm2 class="pl-2">
            <v-text-field
              label="Date Start"
              v-model="dateFrom"
              type="date"
            />
          </v-flex>

          <v-flex xs12 sm2 class="pl-2">
            <v-text-field
              label="Date End"
              v-model="dateTo"
              type="date"
            />
          </v-flex>

          <v-flex xs12 class="layout justify-end">
            <div>
              <v-btn
                v-if="hasPendingFilterChanges"
                class="mr-2"
                flat
                :disabled="loadingFilters"
                @click="undoFilterChanges"
              >
                <v-icon small left>fas fa-undo</v-icon>
                Undo
              </v-btn>
              <v-btn color="primary" :disabled="loadingFilters" @click="applyFilters">
                Apply Filters
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 v-if="requiresAccountOwnerSelection">
        <v-alert type="info" :value="true" outlined dense class="mb-4">
          Please select an account owner to view reports.
        </v-alert>
      </v-flex>

      <v-flex xs12 v-if="!requiresAccountOwnerSelection">
        <distance-travelled-reports
          v-if="appliedReportParams.reportType === 'distance_travelled'"
          :report-type="appliedReportParams.reportType"
          :vehicle-ids="appliedReportParams.vehicleIds"
          :date-from="appliedReportParams.dateFrom"
          :date-to="appliedReportParams.dateTo"
        />
        <ticket-revenue-reports
          v-else-if="appliedReportParams.reportType === 'ticket_revenue'"
          :vehicle-ids="appliedReportParams.vehicleIds"
          :date-from="appliedReportParams.dateFrom"
          :date-to="appliedReportParams.dateTo"
          :is-transportation-owner-user="isTransportationOwnerUser"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style scoped>
.native-date-input {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  min-height: 38px;
  padding: 6px 10px;
}

.selection-summary-text {
  display: inline-block;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-selection-text {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-owner-filter-col {
  min-width: 0;
}

.account-owner-select {
  width: 100%;
}

.account-owner-select /deep/ .v-input__slot,
.account-owner-select /deep/ .v-select__slot,
.account-owner-select /deep/ .v-select__selections {
  min-width: 0;
}

.account-owner-select /deep/ .v-select__selections {
  max-width: calc(100% - 52px);
  overflow: hidden;
  flex-wrap: nowrap;
}

.selection-summary-count {
  color: rgba(0, 0, 0, 0.6);
  margin-left: 8px;
  white-space: nowrap;
}

</style>

<script>
import src from './src'
export default src
</script>
